import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { useAppSelector } from "./store/hooks";
import { Toaster } from "react-hot-toast";
import Loader from "./components/loader/BeatLoader";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const isLoading = useAppSelector((state) => state.loader.isLoading);
  return (
    <>
      <div>
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            // Define default options
            position: "top-right",
            duration: 3000,
            // Default options for specific types
            error: {
              duration: 5000,
            },
          }}
        />
      </div>
      {isLoading && <Loader loading={isLoading} />}
      <AppRoutes />
    </>
  );
}

export default App;
